import { useCallback, useRef, useState } from 'react';

/**
 * Ensures cycling FTP is available for FIT export: resolves immediately when cached,
 * otherwise opens a modal and resolves when the user confirms or cancels.
 */
export function useFitFtpGate(storedFtp: number | null) {
  const fitFtpResolveRef = useRef<((v: number | null) => void) | null>(null);
  const [fitFtpModalOpen, setFitFtpModalOpen] = useState(false);

  const ensureFtpForCyclingFit = useCallback((): Promise<number | null> => {
    if (typeof storedFtp === 'number' && Number.isFinite(storedFtp) && storedFtp >= 30) {
      return Promise.resolve(Math.round(storedFtp));
    }
    return new Promise((resolve) => {
      fitFtpResolveRef.current = resolve;
      setFitFtpModalOpen(true);
    });
  }, [storedFtp]);

  const resolveFitFtp = useCallback((value: number | null) => {
    const r = fitFtpResolveRef.current;
    fitFtpResolveRef.current = null;
    r?.(value);
  }, []);

  const cancelFitFtpModal = useCallback(() => {
    setFitFtpModalOpen(false);
    resolveFitFtp(null);
  }, [resolveFitFtp]);

  const confirmFitFtpModal = useCallback(
    (n: number) => {
      setFitFtpModalOpen(false);
      resolveFitFtp(Math.round(n));
    },
    [resolveFitFtp],
  );

  return {
    fitFtpModalOpen,
    setFitFtpModalOpen,
    ensureFtpForCyclingFit,
    cancelFitFtpModal,
    confirmFitFtpModal,
  };
}
